import {put, call} from 'typed-redux-saga';
import {SagaIterator} from 'redux-saga';
import {showSuccess, ErrorResponse} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';

import {resetSamplesSelection} from '../../actions';
import {reloadMeasurements} from './measurementsSagaUtils';

const title = 'Nastavení dotace';

export function* handleSuccess(): SagaIterator {
    yield* put(showSuccess(title, 'Dotace byly úspěšně nastaveny'));
    yield* put(resetSamplesSelection());
    yield* call(reloadMeasurements);
}

export function* handleErrorResponse(response: ErrorResponse): SagaIterator {
    yield* call(handleResponseError, response, title);
}
